import { rgba } from 'polished';

// blues
export const MangoNavy = '#030d1d';
export const MangoBlue = '#4f86c6';
export const MangoBrightBlue = '#1c73ff';
export const MangoAnotherBlue = '#0089ff';
export const MarineBlue = '#4FB0C6';

// whites
export const White = '#ffffff';
export const White1 = '#f5f5f5';
export const White2 = '#f2f2f2';

// greys
export const Grey = '#ddd';
export const Grey1 = '#e3e7ec';
export const Grey2 = '#7C7C94';

// blacks
export const Black = '#000000';
export const Black1 = '#222222';
export const Black2 = '#42424a';
export const Black3 = '#09101b';

// reds
export const Red = '#FF4136';

// delivery status
export const DeliveredStatus = '#13BC86';
export const InProgressStatus = '#FF9400';
export const OnRoadStatus = '#e85394';

// order / item status
export const ReceivedStatus = '#7C7C94';
export const ProcessedStatus = '#7756BD';
export const PartShippedStatus = '#DE7DAB';
export const ShippedStatus = '#C37DDE';
export const PartDeliveredStatus = '#61B8CC';
export const PartInvoicedStatus = '#DE7D7D';
export const InvoicedStatus = '#369190';
export const PotentialStatus = '#eac029';
export const RejectedStatus = '#D42E12';

// mrp badge background
export const StockBackground = rgba(19, 188, 134, 1);
export const DelvryBackground = rgba(25, 88, 161, 0.2);
export const ShpgNtBackground = rgba(119, 86, 189, 0.2);
export const PrdOrdBackground = rgba(217, 107, 160, 0.2);
export const CusOrdBackground = rgba(124, 124, 148, 0.2);
export const POitemBackground = rgba(42, 195, 146, 0.2);
export const OrdResBackground = rgba(76, 165, 255, 0.2);

// mrp badge font
export const StockColor = `#FFFFFF`;
export const DelvryColor = '#1958A1';
export const ShpgNtColor = '#7756BD';
export const PrdOrdColor = '#B04F7E';
export const CusOrdColor = '#3C3C43';
export const POitemColor = '#0D460F';
export const OrdResColor = '#498FFF';
